import axios from "axios";
import { firebaseRequestURI } from "../../utils/_helpers";
export const LOADING_POPULAR_RESTAURANTS = "LOADING_POPULAR_RESTAURANTS";
export const POPULAR_RESTAURANTS_LOADED = "POPULAR_RESTAURANTS_LOADED";
export const POPULAR_RESTAURANTS_LOADED_ERROR =
  "POPULAR_RESTAURANTS_LOADED_ERROR";

export const getPopularRestaurants =
  (startDate, endDate, type) => (dispatch) => {
    dispatch({ type: LOADING_POPULAR_RESTAURANTS });
    axios({
      method: "GET",
      url: `${firebaseRequestURI}/restaurants?startDate=${startDate}&endDate=${endDate}&type=${type}`,
    })
      .then((response) => {
        dispatch({
          type: POPULAR_RESTAURANTS_LOADED,
          payload: response.data.mostPopularRestaurants,
        });
      })
      .catch((error) => {
        dispatch({
          type: POPULAR_RESTAURANTS_LOADED_ERROR,
          payload:
            error?.response?.data?.message ||
            "Something went wrong, please try again.",
        });
      });
  };
